import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as EmptyIcon } from '../../assets/images/icons/nerdium.svg';
import { Button } from '../UI-CHAKRA/Button';
import FreeSampleHeader from './FreeSampleHeader';

interface FreeSampleEmptyStepProps {
  onClose: () => void;
}

// Estado vazio de catálogo (Figma, seção "Empty state") — quando não há nenhuma marca ativa na
// campanha no momento (diferente do "não encontrei nada pra essa busca", que fica no próprio step
// de catálogo).
const FreeSampleEmptyStep: React.FC<FreeSampleEmptyStepProps> = ({ onClose }) => {
  return (
    <Flex flexDirection={'column'} height={'100%'} overflow="hidden">
      <FreeSampleHeader onClose={onClose} />

      <Box flexGrow={1} overflowY={'auto'} overflowX="hidden" padding={'40px 24px'}>
        <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'} gap={'16px'} minH={'320px'}>
          <EmptyIcon width={'96px'} height={'96px'} />

          <Text fontSize={'18px'} fontWeight={700} color={'#343A40'} textAlign={'center'}>
            Nenhuma amostra disponível agora
          </Text>

          <Text fontSize={'14px'} color={'#6C757D'} textAlign={'center'} maxW={'320px'}>
            Os laboratórios parceiros definem quais amostras ficam disponíveis. Assim que houver novidade, elas aparecem
            aqui.
          </Text>
        </Flex>
      </Box>

      <Box flexShrink={0} padding={'20px'} borderTop={'1px solid #E9ECEF'}>
        <Flex flexDirection={'row'} gap={'12px'} justifyContent={'flex-end'}>
          <Button
            onClick={onClose}
            padding="10px 20px"
            backgroundColor={'#FFF'}
            borderWidth={'2px'}
            borderColor={'primary.main'}
            borderStyle={'solid'}
            borderRadius={'20px'}
            _hover={{ backgroundColor: '#FFF', borderColor: '#6B409C' }}
          >
            <Text fontSize={'14px'} color={'primary.main'}>
              Fechar
            </Text>
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
};

export default FreeSampleEmptyStep;
